import { ROUTE_NAMES } from '@/constants/route-names';
import icon from '@/presentation/assets/images/icons/tool-specification.svg';
import type { CustomQueryParams } from '@/services/router-proxy/types';
import { type Manifest, type RouterConfig, type ToolConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.TOOL,
    name: ROUTE_NAMES.SPECIFICATION,
    exclusiveRoutePath: '/specification',
    getComponent: () => import('./Specification.vue'),
};

const toolConfig: ToolConfig = {
    tabIndex: 3,
    label: 'drafting.Spec',
    icon,
    aclCheckPath: (permission) => {
        return permission.specificationCn || permission.specificationUs;
    },
};

export const manifest: Manifest = {
    ...routerConfig,
    ...toolConfig,
};

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到 AI Specification 页面
         * @param commandId - 命令(去到 AI Specification 页面)
         * @param params - 参数(包含任务 ID)
         */
        executeCommand(commandId: 'command:route:specification', params?: CustomQueryParams): void;
        /**
         * 去到 AI Specification 页面(新窗口打开)
         * @param commandId - 命令(去到 AI Specification 页面(新窗口打开))
         * @param taskId - 任务 ID, 如果未提供，即创建新任务
         */
        executeCommand(commandId: 'command:route:specification:new-tab', taskId?: string): void;
    }
}
